import styled, { css } from "styled-components"
import React from "react"

const StyledImage = styled.img``

export const CoverImage = ({ src, title, className }) => {
  return (
    <StyledImage src={src} alt={`Cover Image for ${title}`} className={className} />
  )
}
